import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';

interface VoidedOrderErrorPopupProps {
    onClose: () => void;
}

const VoidedOrderErrorPopup: React.FC<VoidedOrderErrorPopupProps> = ({ onClose }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.50 : windowSize.width * 0.9,
            backgroundColor: '#ffe8e6',
            position: 'absolute',
            zIndex: 1001,
            top:  55,
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderColor: '#EE3A2A',
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: 8
        },
        input: {
            shadowOpacity: 0,
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            height: 35
        }
    });


    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-2 py-3 gap-2'>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginTop: 2}}>
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 16H12.01" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 8V12" stroke="#A51B0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div className='col d-flex flex-column'>
                    <b style={{ color: '#2A2A37' }}>Warning</b>
                    <small>You are in a voided order. You need to make a payment or delete the order</small>
                </div>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12" stroke="#2A2A37" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M4 4L12 12" stroke="#2A2A37" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    );
};



export default VoidedOrderErrorPopup;

